/*
 * @Description:
 * @Author: lanzhisheng
 * @Date: 2023-03-01 14:09:35
 * @LastEditTime: 2023-03-01 17:41:09
 * @LastEditors: lanzhisheng
 */
import React, { useState,  useEffect } from "react";
import axios from "axios";
import { Space } from "antd-mobile";
import { useNavigate, useLocation } from "react-router-dom";
import { parseQueryString } from "../interface";
import { domain } from "../interface";
import { DemoBlock } from "../demoblock";
import {
  ContentOutline, PlayOutline, StopOutline,
  PhoneFill,
  UndoOutline,
  TravelOutline,
  UserOutline,MovieOutline
} from 'antd-mobile-icons'



import 'antd/dist/antd.css';
import "./index.css";
let userToken = "";
const Main = () => {
  let navigate = useNavigate();
  let location = useLocation();
  const [isDisabled, setIsDisabled] = useState(false)

  const goTo = (path) => {
    // console.log("---path----", path, location);
    navigate(path);
  };

  useEffect(() => {
    const query = parseQueryString(window.location.href);
    if (localStorage.getItem("queryCode") === query.code) {
      return;
    }

    axios
      .post(domain + "/form/login", { code: query.code })
      .then((res) => {
        if (res.status == 200 && res.data && res.data.code == "200") {
          localStorage.setItem("userId", res.data.user_id);
          localStorage.setItem("userName", res.data.user_name);
          localStorage.setItem("queryCode", query.code);
          localStorage.setItem("userToken", res.data.token);
          userToken = res.data.token;
        }
      })
      .catch((error) => {
        alert("corpId err, " + JSON.stringify(error));
      });
  });

  const userId = localStorage.getItem("userId")===null ? "" : localStorage.getItem("userId");
  if ( process.env.NODE_ENV === "sit" && localStorage.getItem("userName")===null) {
    localStorage.setItem("userName","陈冬晓");
  }
  const us = ["LiuYing", "ruhua", "LuLvSheng_1", "YuanPeng", "XiaYuanQing", "ChenLeiMing"
    , "LiuShaoJian", "SuYunYuan", "ZhangYang", "TangZhiLiang", "ZhuYiJi", "KeHuYunYing", "FuWuZhiBanHao"
    , "LiYunZheng", "YiSiMuSheJi-HuJunYi", "625843187", "626093425","HuangQingQingGongZuoWeiXin","HuangQingQing","ZhangDongLan"];
    console.log("userId", userId,us.includes(userId) );
  
  const handleClick = (param) => {
    // if (process.env.NODE_ENV !== "development") {
    //   if (userToken===""){
    //     Toast.show({
    //       content: "登录失败！",
    //     });
    //     return;
    //   }
    // }  

    if (param === "distribute") {
      goTo("/distribute");
    }

    if (param === "list") {
      goTo("/list");
    }
    if (param === "selectCustomer") {
        goTo("/selectCustomer");
    }
    if (param === "demoAccountCustomer") {
      goTo("/demoAccountCustomer");
  }

    
    if (param === "accountRegister") {
      if (us.includes(userId) || process.env.REACT_APP_NOT_SECRET_CODE === "sit") {
        goTo("/accountRegister");
      }
    }
    if (param === "accountPause") {
      if (us.includes(userId) || process.env.REACT_APP_NOT_SECRET_CODE === "sit") {
        goTo("/accountPause");
      }
    }
    if (param === "accountDefer") {
      if (us.includes(userId) || process.env.REACT_APP_NOT_SECRET_CODE === "sit") {
        goTo("/accountDefer");
      }
    }
    if (param === "accountChange") {
      if (us.includes(userId) || process.env.REACT_APP_NOT_SECRET_CODE === "sit") {
        goTo("/accountChange");
      }
    }

  };
  return (
    <>

      <div>
        <DemoBlock title='CASE'>
          <Space wrap align='center'>
            <div style={{ textAlign: 'center' }} className="custom-div" onClick={handleClick.bind(this, 'distribute')}>
              <div style={{ display: 'inline-block' }}>
                <PhoneFill type="check-circle" fontSize={48} color='var(--adm-color-primary)' />
                <br />
                <span>CASE添加</span>
              </div>
            </div>

            <div style={{ textAlign: 'center' }} className="custom-div" onClick={handleClick.bind(this, 'list')}>
              <div style={{ display: 'inline-block' }}>

                <ContentOutline type="check-circle" fontSize={48} color='var(--adm-color-primary)' />
                <br />
                <span>查询问题</span>
              </div>
            </div>

          
          </Space>

        </DemoBlock>

      <DemoBlock title='客户上线流程' >
          <Space wrap align='center'>
          <div style={{ textAlign: 'center' }} className="custom-div" onClick={handleClick.bind(this, 'selectCustomer')}>
              <div style={{ display: 'inline-block' }}>

                <UserOutline type="check-circle" fontSize={48} color='var(--adm-color-primary)' />
                <br />
                <span>客户开账号及上线流程</span>
              </div>
            </div>

            {/* <div style={{ textAlign: 'center' }} className="custom-div" onClick={handleClick.bind(this, 'demoAccountCustomer')}>
              <div style={{ display: 'inline-block' }}>

                <MovieOutline type="check-circle" fontSize={48} color='var(--adm-color-primary)' />
                <br />
                <span>演示账号申请</span>
              </div>
            </div> */}

       </Space> 
       </DemoBlock>
        <DemoBlock title='账号管理' hidden={!us.includes(userId)}>
          <Space wrap align='center'>
            <div style={{ textAlign: 'center' }} className="custom-div" onClick={handleClick.bind(this, 'accountRegister')}>
              <div style={{ display: 'inline-block' }}>

                <PlayOutline type="check-circle" fontSize={48} color='var(--adm-color-primary)' />
                <br />
                <span>开户</span>
              </div>
            </div>

            <div style={{ textAlign: 'center' }} className="custom-div"
              onClick={handleClick.bind(this, 'accountPause')}>
              <div style={{ display: 'inline-block' }}>
                <StopOutline type="check-circle" fontSize={48} color='var(--adm-color-primary)' />
                <br />
                <span>停用/启用</span>
              </div>
            </div>

            <div style={{ textAlign: 'center' }} className="custom-div" onClick={handleClick.bind(this, 'accountDefer')}>
              <div style={{ display: 'inline-block' }}>
                <UndoOutline type="check-circle" fontSize={48} color='var(--adm-color-primary)' />
                <br />
                <span>增购</span>
              </div>
            </div>

            <div style={{ textAlign: 'center' }} className="custom-div" onClick={handleClick.bind(this, 'accountChange')}>
              <div style={{ display: 'inline-block' }}>
                <TravelOutline type="check-circle" fontSize={48} color='var(--adm-color-primary)' />
                <br />
                <span>版本调整</span>
              </div>
            </div>

          </Space>
        </DemoBlock>
      </div>
    </>
  );
};
export default Main;
